const USER_FACING_MESSAGES = [
  'This person already exists.',
  'is already named in your remainder of estate',
  'is named in your family obliteration clause and cannot be removed here',
  'Heir can not be deleted.',
];

export function userFacingGraphQLError(error) {
  const message = error?.graphQLErrors?.[0]?.message;
  if (!message) return null;

  return USER_FACING_MESSAGES.some(text => message.includes(text))
    ? message
    : null;
}
